"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabA11y = exports.DropdownTabs = exports.Tabs = void 0;
var Tabs_1 = require("./Tabs");
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return Tabs_1.Tabs; } });
var DropdownTabs_1 = require("./DropdownTabs/DropdownTabs");
Object.defineProperty(exports, "DropdownTabs", { enumerable: true, get: function () { return DropdownTabs_1.DropdownTabs; } });
var useTabA11y_1 = require("./useTabA11y");
Object.defineProperty(exports, "useTabA11y", { enumerable: true, get: function () { return useTabA11y_1.useTabA11y; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map